import { render } from "./AssignUsersModal.vue?vue&type=template&id=3eff206e&ts=true"
import script from "./AssignUsersModal.vue?vue&type=script&lang=ts"
export * from "./AssignUsersModal.vue?vue&type=script&lang=ts"

import "./AssignUsersModal.vue?vue&type=style&index=0&id=3eff206e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__